import { createClassName } from 'utils/createClassName';

import './dropdownStyles.scss';

export const createDropdownClassName = createClassName('dropdown');
